module.exports = __webpack_public_path__ + "ohen-znamenko-portskeho-vina_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/ohen-znamenko-portskeho-vina_2_before_tn.jpg
// module id = 1436
// module chunks = 0